export interface Purchase {
  name: string
  city: string
  region: string
}

export const purchases: Purchase[] = [
  { name: 'Caroline Hartley', city: 'Gloucestershire', region: 'United Kingdom' },
  { name: 'James Whitfield', city: 'Surrey', region: 'United Kingdom' },
  { name: 'Fiona MacLeod', city: 'Perthshire', region: 'United Kingdom' },
  { name: 'Emily Prescott', city: 'Cheshire', region: 'United Kingdom' },
  { name: 'Megan Dawson', city: 'Calgary', region: 'Canada' },
  { name: 'Ryan Caldwell', city: 'Toronto', region: 'Canada' },
  { name: 'Marc Tremblay', city: 'Montreal', region: 'Canada' },
  { name: 'Robert Kensington', city: 'Scottsdale', region: 'United States' },
  { name: 'Karen Mitchell', city: 'Lexington', region: 'United States' },
  { name: 'Brian Kessler', city: 'Ocala', region: 'United States' },
  { name: 'Lucy Fairbanks', city: 'Melbourne', region: 'Australia' },
  { name: 'Andrew Pike', city: 'Sydney', region: 'Australia' },
  { name: 'Emma Sullivan', city: 'Gold Coast', region: 'Australia' },
  { name: 'Gavin Reid', city: 'Perth', region: 'Australia' },
]
